export const VIDEO_ASPECT_RATIO = 16 / 9;
